module.exports = __webpack_public_path__ + "img/lock.d3614e73.svg";